<template>
  <div class="contain">
    <div class="list">
      <div class="title">{{content.title}}</div>
      <div class="time">{{content.createTimeStr.substr(0,10)}}</div>
    </div>
    <div class="description">
      <div class="riskTitle">风险处理：</div>
      <div class="riskContent" v-html="content.treatment.replace(/\n/g, '<br/>')"></div>
      <div class="riskTitle">风险行为：</div>
      <div class="riskContent" v-html="content.behavior.replace(/\n/g, '<br/>')"></div>
    </div>
    
  </div>
</template>

<script>

export default {
  computed: {},
  components: {
   
  },
  data() {
    return {
      content:''
    };
  },
  created() {
    this.content = JSON.parse(this.$route.query.notData)
    document.title = this.$route.meta.title || "通知详情";
  },
  mounted() {
  
  },
  methods: {

  },
};
</script>


<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .contain {
    .list {
      margin: 32px;
      padding-bottom: 34px;
      border-bottom: 1px solid #E6E6E6;
      .title{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #323232;
        line-height: 40px;
      }
      .time{
        margin-top: 8px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 40px;
      }
    }
    .description{
      margin: 0 32px;
      .riskTitle{
        margin-top: 32px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #58ABF6;
      }
      .riskContent{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #323232;
        line-height: 40px;
      }
    }
    
  }
</style>
